import { QuestHome } from './QuestHome';
import { UiFeatureLite } from '@/app/feature';
import { FeatureCodes } from '@ssar-app/domain';

export const questFeature: UiFeatureLite = {
  code: FeatureCodes.AscendQuest,
  rootComponent: <QuestHome />,
};
